import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = ({ data }) => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [aboutOpen, setAboutOpen] = useState(false);
    const [membershipOpen, setMembershipOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setMobileMenuOpen(false);
        setAboutOpen(false);
        setMembershipOpen(false);
    }, [location]);

    if (!data) return null;

    const close = () => { setMobileMenuOpen(false); setAboutOpen(false); setMembershipOpen(false); };

    return (
        <header className={`header ${scrolled ? 'scrolled' : ''}`}>
            <div className="header-top">
                <div className="container">
                    <div className="header-top-content">
                        <div className="header-contact">
                            <span><i className="fas fa-envelope"></i> mncwestv@gmail.com</span>
                        </div>
                        <div className="header-social">
                            <span>Follow us:</span>
                            <a href={data.facebookUrl} target="_blank" rel="noopener noreferrer">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <nav className="navbar">
                <div className="container">
                    <div className="navbar-content">
                        <Link to="/" className="navbar-brand" onClick={close}>
                            <img src={data.logo.src} alt={data.logo.alt} className="logo" />
                            <div className="brand-text">
                                <h1>{data.name}</h1>
                                <p className="tagline">{data.tagline}</p>
                            </div>
                        </Link>

                        <button
                            className={`mobile-toggle${mobileMenuOpen ? ' open' : ''}`}
                            onClick={() => setMobileMenuOpen(o => !o)}
                            aria-label="Toggle menu"
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>

                        <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
                            <li><Link to="/" onClick={close}>Home</Link></li>

                            <li className="has-dropdown">
                                <button
                                    type="button"
                                    className="nav-parent"
                                    onClick={() => setAboutOpen(o => !o)}
                                    aria-expanded={aboutOpen}
                                >
                                    About <i className={`fas fa-chevron-down dropdown-icon ${aboutOpen ? 'rotated' : ''}`}></i>
                                </button>
                                <ul className={`dropdown-menu ${aboutOpen ? 'open' : ''}`}>
                                    <li><Link to="/about-us" onClick={close}>About Us</Link></li>
                                    <li><Link to="/team" onClick={close}>Our Team</Link></li>
                                    <li><Link to="/cricket-club" onClick={close}>Cricket Club</Link></li>
                                    <li><Link to="/faq" onClick={close}>FAQ</Link></li>
                                </ul>
                            </li>

                            <li><Link to="/news" onClick={close}>News</Link></li>
                            <li><Link to="/events" onClick={close}>Events</Link></li>
                            <li><Link to="/gallery" onClick={close}>Gallery</Link></li>
                            <li className="has-dropdown">
                                <button
                                    type="button"
                                    className="nav-parent"
                                    onClick={() => setMembershipOpen(o => !o)}
                                    aria-expanded={membershipOpen}
                                >
                                    Membership <i className={`fas fa-chevron-down dropdown-icon ${membershipOpen ? 'rotated' : ''}`}></i>
                                </button>
                                <ul className={`dropdown-menu ${membershipOpen ? 'open' : ''}`}>
                                    <li><Link to="/membership" onClick={close}>Join / Register</Link></li>
                                    <li><Link to="/membership-lookup" onClick={close}>Check My Membership</Link></li>
                                </ul>
                            </li>
                            <li><Link to="/feedback" onClick={close}>Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
